"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = void 0;
const stringify = (params) => {
    const keys = Object.keys(params)
        // Alphabetize the keys
        .sort((a, b) => a.localeCompare(b))
        // Filter out null or undefined values
        .filter((key) => params[key] != null);
    return keys
        .map((key) => {
        return `${key}=${encodeURIComponent(`${params[key]}`)}`;
    })
        .join("&");
};
exports.stringify = stringify;
